import { useEffect } from 'react';
import { requestNotificationPermission, onMessageListener } from '../config/firebase';
import { app } from 'application';

export const useNotifications = (authed: boolean | null | undefined) => {
  useEffect((): void => {
    if (!authed) return;
    const initializeNotifications = async () => {
      const token = await requestNotificationPermission();
      await app().userStore.updateFCMToken(token);
    };

    initializeNotifications();

    onMessageListener().then(async (payload: unknown) => {
      if (payload) {
        await app().creativesStore.getFirstPage();
      }
    });
  }, [authed]);
};
